import { ref } from 'vue'

export function useSendButton() {
  const restSeconds = ref(0)
  let timer: number | undefined

  function countDown() {
    clearCountDown()
    restSeconds.value = 60
    timer = window.setInterval(() => {
      restSeconds.value -= 1
      if (restSeconds.value === 0) {
        clearCountDown()
      }
    }, 1000)
  }

  function clearCountDown() {
    if (timer) {
      window.clearInterval(timer)
      timer = undefined
    }
    restSeconds.value = 0
  }

  return {
    restSeconds,
    countDown,
    clearCountDown,
  }
}
